import React from "react"
import { Link, useParams } from "react-router-dom"
import ContentHeader from "../components/ContentHeader"
import ContentMain from "../components/ContentMain"
import ContentWrapper from "../components/ContentWrapper"
import DisplayManageDetails from "../components/DisplayManageDetails"
import DisplayManageTable from "../components/DisplayManageTable"
import DisplayManageForm from "../components/DisplayManageForm"

export default function MainDisplayManage() {
  // State
  let { displayId } = useParams()

  // Comportements

  // Rendu
  return (
    <ContentWrapper>
      <ContentHeader>
        <div className="col-sm-6">
          <h1 className="m-0">Gestion des emplacements</h1>
        </div>
        <div className="col-sm-6">
          <ol className="breadcrumb float-sm-right">
            <li className="breadcrumb-item">
              <Link to={"/"}>Tableau de bord</Link>
            </li>
            {displayId === "nouveau" ? (
              <>
                <li className="breadcrumb-item">
                  <Link to={"/display/gestion"}>Emplacements</Link>
                </li>
                <li className="breadcrumb-item active">Nouveau</li>
              </>
            ) : displayId ? (
              <>
                <li className="breadcrumb-item">
                  <Link to={"/display/gestion"}>Emplacements</Link>
                </li>
                <li className="breadcrumb-item active">{displayId}</li>
              </>
            ) : (
              <li className="breadcrumb-item active">Emplacements</li>
            )}
          </ol>
        </div>
      </ContentHeader>
      <ContentMain>
        {displayId === "nouveau" ? (
          <DisplayManageForm />
        ) : displayId ? (
          <DisplayManageDetails displayId={displayId} />
        ) : (
          <DisplayManageTable />
        )}
      </ContentMain>
    </ContentWrapper>
  )
}
